import { render } from "./ParameterView.vue?vue&type=template&id=2789a432&scoped=true"
import script from "./ParameterView.vue?vue&type=script&lang=js"
export * from "./ParameterView.vue?vue&type=script&lang=js"

import "./ParameterView.vue?vue&type=style&index=0&id=2789a432&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2789a432"]])

export default __exports__